import { cls_login } from "./pages/login/login.component";
import { cls_recupMdp } from "./pages/recupMDP/recupMDP.component";
import { cls_register } from "./pages/register/register.component";

import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";

const routes: Routes = [
  {
    path: "pages",
    loadChildren: "app/pages/pages.module#PagesModule"
  },
  {
    path: "auth",
    children: [
      {
        path: "login",
        component: cls_login
      },
      {
        path: "login/:tiersId",
        component: cls_login
      },
      {
        path: "register",
        component: cls_register
      },
      {
        path: "register/:tiersId",
        component: cls_register
      },
      {
        path: "recupMDP",
        component: cls_recupMdp
      }
    ]
  },

  { path: "", redirectTo: "auth/login", pathMatch: "full" },
  { path: "**", redirectTo: "auth/login" }
];

const config: ExtraOptions = {
  useHash: true,
  onSameUrlNavigation: "reload"
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/app-routing.module.ts